import { Box, useTheme } from '@mui/material';
import React from 'react';
import useOffsetTop from '../../hooks/ui/useOffsetTop';

const PADDING = 16;

interface Props extends React.PropsWithChildren {}

function OutlinedPageBox({ children }: Props) {
  const theme = useTheme();
  const [containerRef, offsetTop, onChange] = useOffsetTop();
  return (
    <Box
      ref={el => {
        const htmlEl = el as HTMLElement;
        containerRef.current = htmlEl;
        onChange(htmlEl);
      }}
      position="relative"
      boxSizing="border-box"
      width="100%"
      minHeight={`min(1000px, calc(100vh - ${offsetTop + PADDING}px))`}
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="40px"
      border={`1px solid ${theme.palette.darkerLightGrey.main}`}
      padding={{
        xs: 4,
        md: 5,
      }}>
      {children}
    </Box>
  );
}

export default OutlinedPageBox;
